import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ClinicsService } from '../../services/clinics.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PlansService } from '../../services/plans.service';

@Component({
  selector: 'app-new-lead',
  templateUrl: './new-lead.component.html',
  styleUrls: ['./new-lead.component.scss'],
})
export class NewLeadComponent implements OnInit {
  form: FormGroup;
  previewSrc;
  plan = {
    id: null,
    name: 'Plan Name',
    monthly_price: '000',
  };
  MIN_PW_LENGTH = 5;
  showPassword = false;

  constructor(
    private fb: FormBuilder,
    private clinicsService: ClinicsService,
    private plansService: PlansService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.plan.id = this.route.snapshot.queryParamMap.get('id');
    this.plan.name = this.route.snapshot.queryParamMap.get('n');
    this.plan.monthly_price = this.route.snapshot.queryParamMap.get('p');
    if (!this.plan.id) {
      this.router.navigate(['/404']);
      return;
    }
    this.initForm();
  }

  initForm() {
    const config = {
      name: [null, Validators.required],
      email: [null, Validators.required],
      pw: [null, [Validators.required, Validators.minLength(this.MIN_PW_LENGTH)]],
    };
    this.form = this.fb.group(config);
  }

  get fcName(): AbstractControl {
    return this.form.controls.name;
  }

  get fcEmail(): AbstractControl {
    return this.form.controls.email;
  }

  get fcPw(): AbstractControl {
    return this.form.controls.pw;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
    const fd = this.form.value;
    const data = {
      clinic_name: fd.name,
      email: fd.email,
      password: fd.pw,
      payment_plan: this.plan.id,
    };
    this.clinicsService.createLead(data).subscribe(r => {
      window.location.href = r.checkout_url;
    });
  }
}
